export const FileCheck = ({ size = 20, className, bold }) => {
  return bold ? (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.33203 2V4.66667C9.33203 5.03486 9.63051 5.33333 9.9987 5.33333H12.6654"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.332 14H4.66536C3.92898 14 3.33203 13.403 3.33203 12.6667V3.33333C3.33203 2.59695 3.92898 2 4.66536 2H9.33203L12.6654 5.33333V12.6667C12.6654 13.403 12.0684 14 11.332 14Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 9.99935L7.33333 11.3327L10 8.66602"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ) : (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.666 2.5V5.83333C11.666 6.29357 12.0391 6.66667 12.4993 6.66667H15.8327"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.166 17.5H5.83268C4.91221 17.5 4.16602 16.7538 4.16602 15.8333V4.16667C4.16602 3.24619 4.91221 2.5 5.83268 2.5H11.666L15.8327 6.66667V15.8333C15.8327 16.7538 15.0865 17.5 14.166 17.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 12.5007L9.16667 14.1673L12.5 10.834"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
